import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useDispatch } from 'react-redux';
import { changeTabActive } from '../redux/action';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes } from '@fortawesome/free-solid-svg-icons';
import '../styles/NavBar.css';

const NavBar = ({ activeTab }) => {
  const dispatch = useDispatch();
  const [linkNav] = useState(['Home', 'Skills', 'Experience', 'Projects', 'Contacts', 'Games']);
  const [statusNav, setStatusNav] = useState(false);
  const [logoSrc, setLogoSrc] = useState('/SSanW2.png');
  const navRef = useRef(null);
  const iconBarRef = useRef(null);
  const scrollTimeoutRef = useRef(null);

  const toggleNav = () => {
    setStatusNav(prevStatus => !prevStatus);
  }

  const closeNav = () => {
    setStatusNav(false);
  };

  const changeTab = (value) => {
    if (value === 'Games') {
      window.open('/assets/Arcade-Games-JS-main/index.html', '_blank', 'noopener,noreferrer');
      closeNav();
      return;
    }
    dispatch(changeTabActive(value));
    closeNav();
    
    // Clear any existing timeout
    if (scrollTimeoutRef.current) {
      clearTimeout(scrollTimeoutRef.current);
    }

    // Set a timeout to remove the active state after scrolling
    scrollTimeoutRef.current = setTimeout(() => {
      dispatch(changeTabActive(''));
    }, 1000); // Adjust timing based on your scroll animation duration
  }

  useEffect(() => {
    const updateLogo = () => {
      const text = window.getComputedStyle(document.body).color;
      const isDark = text === 'rgb(0, 0, 0)';
      setLogoSrc(isDark ? '/SSanB2.png' : '/SSanW2.png');
    };

    updateLogo();
    window.addEventListener('resize', updateLogo);

    // Clean up scroll timeout on unmount
    return () => {
      window.removeEventListener('resize', updateLogo);
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideNav = navRef.current && navRef.current.contains(event.target);
      const clickedOnIconBar = iconBarRef.current && iconBarRef.current.contains(event.target);
  
      if (!clickedInsideNav && !clickedOnIconBar) {
        closeNav();
      }
    };
  
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  

  return (
    <header>
      <div className="logo" onClick={() => changeTab('Home')}>
        <img src={logoSrc} alt="Logo" />
      </div>
      <div className="icon-bar" ref={iconBarRef} onClick={statusNav ? closeNav : toggleNav}>
        <FontAwesomeIcon icon={statusNav ? faTimes : faBars} size="2x" />
      </div>
      <nav className={statusNav ? 'active' : ''} ref={navRef}>
        {
          linkNav.map(value => (
            <span key={value}
              className={activeTab === value ? 'active' : ''}
              onClick={() => changeTab(value)}>
              {value}
            </span>
          ))
        }
      </nav>
    </header>
  );
}

const mapStateToProps = (state) => ({
  activeTab: state.activeTab
})

export default connect(mapStateToProps, { changeTabActive })(NavBar);